// extracted by mini-css-extract-plugin
export default {"loader":"SmallLoader_loader__lFywC","rotation":"SmallLoader_rotation__QBeA6"};